module.exports = __webpack_public_path__ + "static/media/logo.ea57c121.png";